import { render, staticRenderFns } from "./EmployerRegistrationDetails.vue?vue&type=template&id=dd32459a&"
import script from "./EmployerRegistrationDetails.vue?vue&type=script&lang=ts&"
export * from "./EmployerRegistrationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports